import * as React from 'react';
import { Route } from 'react-router-dom';
import Unauthorized from './Unauthorized';
import NotFound404 from './NotFound404';

const ProtectedRoute = (props: any) => {
  const {
    isAllowed = null,
    component: Component,
  } = props;

  return (
    <Route
      {...props}
      component={(routeProps) => {
        if (isAllowed === false) {
          return <Unauthorized title="Unauthorized" />;
        }

        if (Component) {
          return <Component {...routeProps} />;
        }

        return <NotFound404 />;
      }}
    />
  );
};

export default ProtectedRoute;
